import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog7() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4"> Culture Eats Strategy for Breakfast: Why We Obsess Over Community</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
           
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img
            src="https://res.cloudinary.com/diecfwnp9/image/upload/v1761551272/WhatsApp_Image_2025-10-27_at_08.38.52_1_a725h2.jpg"
            alt="Where Women Rise Together"
            className="w-full h-64 sm:h-96 object-cover"
          />
        </div>

        <div className="prose max-w-none mt-6">
          <p>
            Peter Drucker’s famous line—“Culture eats strategy for breakfast”—is more than a clever quote. For us at Hightable, it’s a daily reminder that while strategies can be drawn on slides, culture is lived in every interaction.
          </p>

          <h3>Why Culture Wins Every Time</h3>
          <p>
            Startups often begin with decks full of ideas and big plans. But once the real grind starts, what keeps a team moving isn’t the pitch deck—it’s the people and the values they share. At Hightable, our goal to help people find their tribe begins with the culture we build internally.
          </p>

          <h3>Culture Can’t Be Copied</h3>
          <p>
           Here’s the truth: strategies can be copied, features can be cloned, and prices can be undercut. But culture? That’s your secret sauce.

Hightable thrives on authenticity, inclusivity, and a sense of ease. Users don’t feel like they’re “networking.” They feel like they’ve walked into a space where real conversations and real connections happen. That’s culture showing up through community 
    </p>

          <h3>The Loop Between Culture and Community</h3>
          <p>
            The way we operate inside the team—transparent, quirky, and open—shows up in how people experience Hightable. It’s a feedback loop: culture shapes community, and the community reinforces culture.
          </p>

          <h3>Lessons We’ve Learned</h3>
          <ul>
            <li>Small actions matter—culture is built in everyday choices.</li>
            <li>It has to be lived—posters and policies don’t create culture; people do.</li>
          </ul>

          <h3>Why We Obsess</h3>
          <p>
            For us, culture isn’t fluff—it’s the foundation. Every time someone finds belonging on Hightable, it validates what we believe: community grows where culture is strong. Strategy may guide us, but culture gives us soul.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
